import { NavLink } from "react-router-dom";
import classNames from 'classnames';

const MobileNavigationItems = ({ navigation }) => {
  return (
    <div className="max-w-3xl mx-auto px-2 pt-2 pb-3 space-y-1 sm:px-4">
      {navigation.map(({name, ...props}) => (
        <NavLink
          key={name}
          {...props}
          className={({ isActive }) => classNames(
            isActive ? "bg-gray-100 text-gray-900" : "hover:bg-gray-50",
            "block rounded-md py-2 px-3 text-base font-medium"
          )}
        >
          {name}
        </NavLink>
      ))}
    </div>
  );
};

export default MobileNavigationItems;
